import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { create } from 'kts-scaffold-framework/utils/form';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from '../Modules.State';
import ModulesAction from '../Modules.Action';
import withRouter from 'src/routes/withRouter';
import { Form, Row, Col, Select, Tooltip, Drawer, Button } from 'antd';
import IcoCaveat from './img.caveat';
const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
}

/** 绑定全局数据 */
@create()
@withRouter
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
}))
export default class Head extends UIBasic<IProps, ModulesState> {
    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    searchFn = (val: any) => {
        setTimeout(() => {
            this.props.form.validateFields((err, values) => {
                if (!err) {
                    this.modulesState.searchInfo = { ...this.modulesState.searchInfo, ...values };
                    this.modulesState.pageNum = 1;
                    this.setModulesState(this.modulesState, () => {
                        ModulesAction.getAppList();
                    });
                }
            });
        }, 0);

    }
    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div className={css.headFilter}>
                <div className={css.filterForm}>
                    <Form
                        colon={false}
                        labelAlign="left"
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 18 }}
                    >
                        <Row type="flex" justify="start">
                            <Col span={24} style={{height:'80px'}}>
                                {getFieldDecorator('isOpen', {
                                    initialValue: this.modulesState.searchInfo.isOpen
                                })(
                                    <Select className={css.borderLeftRadius} onChange={this.searchFn} style={{ width: '200px' }}>
                                        {this.modulesState.isOpenList.map(item => <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>)}
                                    </Select>
                                )}
                                {getFieldDecorator('appCategoryId', {
                                    initialValue: this.modulesState.searchInfo.appCategoryId ? this.modulesState.searchInfo.appCategoryId : this.modulesState.appCategoryList.length !== 0 && this.modulesState.appCategoryList[0].categoryId
                                })(
                                    <Select placeholder="请选择平台" className={css.borderRightRadius} onChange={this.searchFn} style={{ width: '200px',marginTop:'20px' }}>
                                        {
                                            this.modulesState.appCategoryList && this.modulesState.appCategoryList.map(({ categoryId, categoryName }) => {
                                                return <Select.Option key={categoryId} value={categoryId}>{categoryName}</Select.Option>;
                                            })
                                        }
                                    </Select>
                                )}
                            </Col>
                        </Row>
                    </Form>
                </div>
                <div className={css.btnBox} >
                    <div className={css.prompt} >
                        <Tooltip title="仅展示未激活的应用。">
                            <p>
                                <i dangerouslySetInnerHTML={{ __html: IcoCaveat }} />
                                仅展示未激活的应用
                            </p>
                        </Tooltip>
                    </div>
                    <Button
                        type="primary"
                        shape="round"
                        size="small"
                        className={!(this.modulesState.appList && this.modulesState.appList.filter(item => !item.isActivated).length > 0) ? css.antdBtnDesible : css.antdBtn}
                        disabled={!(this.modulesState.appList && this.modulesState.appList.filter(item => !item.isActivated).length > 0)}
                        onClick={ModulesAction.checkedAll}
                    >
                        {this.modulesState.isCheckedAll ? '取消全选' : '全选'}
                    </Button>
                    <Button
                        type="primary"
                        shape="round"
                        size="small"
                        className={!(this.modulesState.appList && this.modulesState.appList.filter(item => !item.isActivated).length > 0) ? css.antdBtnDesible : css.antdBtn}
                        disabled={!(this.modulesState.appList && this.modulesState.appList.filter(item => !item.isActivated).length > 0)}
                        onClick={() => { ModulesAction.appBacthHandle(); }}
                    >
                        一键激活
                    </Button>
                    <Button
                        type="primary"
                        shape="round"
                        size="small"
                        className={css.antdBtnGhost}
                        onClick={() => { this.props.history.goBack(); }}
                    >
                        取消
                    </Button>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/AppStore/AppManage/AppBatchActivated/UI.Components/UI.Head.tsx